export enum CallForCompetitionState {
  Draft = "DRAFT",
  Active = "ACTIVE",
  Finished = "FINISHED",
  Completed = "COMPLETED",
  Opened = "REQUESTS_FOR_PARTICIPATION_OPENED",
}
